import React from 'react'
import Navbar from '../inc/Navbar'
import Aboutus from './Aboutus'
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";
function Aboutpage() {
  return (
    <div>
      <Navbar/>
      <br/>
      <br/>
      
      <br/>
        <div className="cctvfotageberhampore">
                <div className="album py-1">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">About us</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        <ScrollToTop smooth top="100" color="maroon" />
        <br/>
      <Aboutus/>
      <br/>
      <br/>


    </div>
  )
}

export default Aboutpage